<template>
  <svg @click="onClick" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"
       stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left">
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
</template>

<script>
export default {
  props: ['onClick'],
  name: "ChevronLeft"
}
</script>

<style scoped>

</style>